module.exports = __webpack_public_path__ + "static/img/pattern_mini_right_top.f361c389.png";